import { __read, __spread } from "tslib";
import fedopsLogger from '../../loggers/fedops/desktop-widget';
import { openFullScreenPurchaseOverlay as openPurchaseOverlay, openFullScreenMemberOnlyOverlay as openMemberOnlyOverlay, openFullScreenSubscribeOverlay as openSubscribeOverlay, openFullScreenRentOverlay as openRentOverlay, } from '../../shared/utils/open-overlay';
import { createProxy } from '../../shared/worker/lib';
export var openFullScreenPurchaseOverlay = createProxy('openFullScreenPurchaseOverlay', function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (dispatch) {
        dispatch(fedopsLogger.loadCashierModal.start());
        dispatch(openPurchaseOverlay.apply(void 0, __spread(args)));
    };
});
export var openFullScreenMemberOnlyOverlay = createProxy('openFullScreenMemberOnlyOverlay', function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (dispatch) {
        dispatch(fedopsLogger.loadCashierModal.start());
        dispatch(openMemberOnlyOverlay.apply(void 0, __spread(args)));
    };
});
export var openFullScreenSubscribeOverlay = createProxy('openFullScreenSubscribeOverlay', function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (dispatch) {
        dispatch(fedopsLogger.loadCashierModal.start());
        dispatch(openSubscribeOverlay.apply(void 0, __spread(args)));
    };
});
export var openFullScreenRentOverlay = createProxy('openFullScreenRentOverlay', function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (dispatch) {
        dispatch(fedopsLogger.loadCashierModal.start());
        dispatch(openRentOverlay.apply(void 0, __spread(args)));
    };
});
